import cn from "classnames";
import { AspectRatio } from "@/constants/media";
import { AspectRatioClassName } from "@/constants/style";

export function getAspectRatioClassName(aspectRatio: AspectRatio) {
  return cn({
    [AspectRatioClassName[AspectRatio.Auto]]: aspectRatio === AspectRatio.Auto,
    [AspectRatioClassName[AspectRatio["1:1"]]]:
      aspectRatio === AspectRatio["1:1"],
    [AspectRatioClassName[AspectRatio["2:1"]]]:
      aspectRatio === AspectRatio["2:1"],
    [AspectRatioClassName[AspectRatio["4:3"]]]:
      aspectRatio === AspectRatio["4:3"],
    [AspectRatioClassName[AspectRatio["16:9"]]]:
      aspectRatio === AspectRatio["16:9"],
    [AspectRatioClassName[AspectRatio["16:10"]]]:
      aspectRatio === AspectRatio["16:10"],
    [AspectRatioClassName[AspectRatio["21:9"]]]:
      aspectRatio === AspectRatio["21:9"],
  });
}
